import { liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { hapticFeedback } from '@tma.js/sdk';
import { type FC, type ReactNode } from 'react';

interface LiquidGlassChipProps {
  icon: ReactNode;
  iconAfter?: ReactNode;
  label: ReactNode;
  subLabel?: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export const LiquidGlassChip: FC<LiquidGlassChipProps> = ({
  icon,
  iconAfter,
  label,
  subLabel,
  selected = false,
  onClick,
  disabled = false,
}) => (
  <Box
    {...(onClick ? { component: 'button', type: 'button', disabled } : {})}
    onClick={onClick && !disabled ? () => {
      hapticFeedback.impactOccurred.ifAvailable('light');
      onClick();
    } : undefined}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '999px',
      padding: '8px 14px',
      boxSizing: 'border-box',
      cursor: onClick && !disabled ? 'pointer' : 'default',
      opacity: disabled ? 0.5 : 1,
      pointerEvents: onClick && !disabled ? 'auto' : undefined,
      appearance: 'none',
      WebkitAppearance: 'none',
      WebkitTapHighlightColor: 'transparent',
      outline: 'none',
      font: 'inherit',
      textAlign: 'left',
      ...liquidGlassSurfaceFillSx,
      ...(selected && { border: '1.5px solid var(--tgui--button_color)' }),
      '&:focus-visible': { outline: '2px solid var(--tg-theme-link-color)', outlineOffset: 2 },
    }}
  >
    {icon}
    <Stack sx={{ minWidth: 0 }}>
      <Text style={{ fontSize: 14, fontWeight: 600, color: 'var(--tg-theme-text-color)', lineHeight: 1.2 }}>
        {label}
      </Text>
      {subLabel && (
        <Text style={{ fontSize: 11, lineHeight: '11px', color: 'var(--tg-theme-hint-color)' }}>{subLabel}</Text>
      )}
    </Stack>
    {iconAfter}
  </Box>
);
